import AssignmentRestriction from '../components/AssignmentRestriction';
import TagsDialog from '../components/TagsDialog';
import WorkspaceSettings from '../components/WorkspaceSettings';
import { SurveySettingsDialogTypes } from '../types';

const surveySettingsDialogs = {
  [SurveySettingsDialogTypes.Tags]: TagsDialog,
  [SurveySettingsDialogTypes.WorkspaceSettings]: WorkspaceSettings,
  [SurveySettingsDialogTypes.AssignmentRestriction]: AssignmentRestriction,
};

export default surveySettingsDialogs;
